/**
 * @typedef {(ACTIVATE | IDLE | SELECT)} TypeAnimation An animation.
 */

/**
 * The 'ACTIVATE' animation.
 * @type {'activate'}
 * @constant
 */
const ACTIVATE = 'activate';

/**
 * The 'IDLE' animation.
 * @type {'idle'}
 * @constant
 */
const IDLE = 'idle';

/**
 * The 'SELECT' animation.
 * @type {'select'}
 * @constant
 */
const SELECT = 'select';

export {

    ACTIVATE,
    IDLE,
    SELECT
};
